module.exports = __webpack_public_path__ + "static/img/swiper_06.2ab4238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/prebook/swiper_06.png
// module id = WS7Y
// module chunks = 1